import { IconName } from "@fortawesome/fontawesome-svg-core";
import moment from "moment";
import { ProdutoConsultaComandoDto } from "src/pages/Privada/Fiscal/NFCe/NFCe.Dto";
import { MenuItemDto } from "src/pages/Privada/Menu/MenuItem.Dto";

export const isValidDate = (dateString: string) => {
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!regex.test(dateString)) return false;

  const [day, month, year] = dateString.split("/").map(Number);

  const isValidMonth = month >= 1 && month <= 12;
  const isValidDay = day >= 1 && day <= 31;
  const isValidYear = year >= 1900 && year <= new Date().getFullYear();

  return isValidMonth && isValidDay && isValidYear;
};

export const MapearErrosServidorCampo = (
  serverErrors: any[],
  setError: any,
) => {
  if (serverErrors) {
    serverErrors.forEach((error) => {
      if (error.tag === "campo" && error.key) {
        const key = error.key.charAt(0).toLowerCase() + error.key.slice(1);
        setError(key, {
          type: "manual",
          message: error.message,
        });
      }
    });
  }
};

export const MapearErrosServidor = (serverErrors: any[], showToast: any) => {
  if (serverErrors) {
    serverErrors
      .filter(
        (item) =>
          (item.tag === "negocio" && item.key === "erro") ||
          (item.key === "no_response" && item.tag === "request_error"),
      )
      .forEach((item) => {
        showToast({
          message: item.message,
          title: "Erro",
          variant: "Danger",
        });
      });
    serverErrors
      .filter((item) => item.tag === "negocio" && item.key === "info")
      .forEach((item) => {
        showToast({
          message: item.message,
          title: "Info",
          variant: "Info",
        });
      });
    serverErrors
      .filter(
        (item) => item.tag === "response_error" && item.key === "status_code",
      )
      .forEach((item) => {
        showToast({
          message: item.message,
          title: "Atenção",
          variant: "Danger",
        });
      });
  }
};

export const SoNumeros = (value: string): string => {
  return value.replace(/[^\d]/g, "");
};

export const TodasMaiusculas = (value: string): string => {
  return value.toUpperCase();
};

export const TodasMinusculas = (value: string): string => {
  return value.toLowerCase();
};

export const Capitalizar = (value: string): string => {
  if (!value) {
    return value;
  }

  return value
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const RemoverZerosEsquerda = (value: string): string => {
  return value.replace(/^0+/, "");
};

export const FormatarTelefone = (value: string): string => {
  const cleanPhoneNumber = SoNumeros(value).slice(0, 11);

  if (cleanPhoneNumber.length === 10) {
    return `(${cleanPhoneNumber.slice(0, 2)}) ${cleanPhoneNumber.slice(
      2,
      6,
    )}-${cleanPhoneNumber.slice(6)}`;
  } else if (cleanPhoneNumber.length === 11) {
    return `(${cleanPhoneNumber.slice(0, 2)}) ${cleanPhoneNumber.slice(
      2,
      7,
    )}-${cleanPhoneNumber.slice(7)}`;
  } else {
    return cleanPhoneNumber;
  }
};

export const FormatarCPF = (value: string): string => {
  const match = SoNumeros(value)
    .slice(0, 11)
    .match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);

  if (!match) {
    return value; // Não deve ocorrer
  }

  const [, part1, part2, part3, part4] = match;

  let formattedValue = "";

  if (part1) {
    formattedValue += part1;
    if (part2) {
      formattedValue += `.${part2}`;
      if (part3) {
        formattedValue += `.${part3}`;
        if (part4) {
          formattedValue += `-${part4}`;
        }
      }
    }
  }

  return formattedValue;
};

export const FormatarCEP = (value: string): string => {
  const cepLimpo = SoNumeros(value);

  const match = cepLimpo.slice(0, 8).match(/^(\d{0,5})(\d{0,3})$/);

  if (!match) {
    return cepLimpo;
  }

  const [, parte1, parte2] = match;

  let formattedValue = "";

  if (parte1) {
    formattedValue += parte1;
    if (parte2) {
      if (parte2.length <= 3) {
        formattedValue += `-${parte2}`;
      } else {
        formattedValue += `-${parte2.slice(0, 3)}`;
      }
    }
  }
  return formattedValue;
};

export const FormatarCNPJ = (cnpj: string): string => {
  const match = SoNumeros(cnpj)
    .slice(0, 14)
    .match(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})$/);

  if (!match) {
    return cnpj;
  }

  const [, part1, part2, part3, part4, part5] = match;

  let formattedCNPJ = "";

  if (part1) {
    formattedCNPJ += part1;
    if (part2) {
      formattedCNPJ += `.${part2}`;
      if (part3) {
        formattedCNPJ += `.${part3}`;
        if (part4) {
          formattedCNPJ += `/${part4}`;
          if (part5) {
            formattedCNPJ += `-${part5}`;
          }
        }
      }
    }
  }

  return formattedCNPJ;
};

export const FormatarDouble = (value: string): string => {
  if (value.length === 1) {
    return `0,0${value}`;
  }

  if (value.length === 2) {
    return `0,${value}`;
  }

  if (value.length > 2) {
    const mainPart = value.slice(0, -2);
    const centsPart = value.slice(-2);
    return `${mainPart},${centsPart}`;
  }

  return "";
};

export function FormatarDataHora(v: string | undefined): string {
  if (!v) return "";

  v = v.replace(/\D/g, "");

  let dia = v.substring(0, 2);
  let mes = v.substring(2, 4);
  let ano = v.substring(4, 8);
  let hora = v.substring(8, 10);
  let min = v.substring(10, 12);
  let seg = v.substring(12, 14);

  let out = "";
  if (dia) out += dia;
  if (mes) out += "/" + mes;
  if (ano) out += "/" + ano;
  if (hora) out += " " + hora;
  if (min) out += ":" + min;
  if (seg) out += ":" + seg;

  return out;
}

export const FormatarDataHoraDefault = (value?: string) => {
  if (!value) return "";
  return moment(value).format("DD/MM/YYYY HH:mm:ss");
};

export async function getBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result as string;
      const base64WithoutPrefix = base64String.split(",")[1];
      resolve(base64WithoutPrefix);
    };
    reader.onerror = reject;
  });
}

export const ValidaGtin = (codigo: string) => {
  if (codigo === "SEM GTIN") return true;
  const length = codigo.length;
  if ([8, 12, 13, 14].includes(length)) return true;
  return false;
};

export const FormatarPontoVirgula = (value: string) => {
  return value.toString().replace(".", ",");
};

export const FormatarVirgulaPonto = (value: string) => {
  return value.toString().replace(",", ".");
};

export function filtrarRotasPorRotaAtual(rotaAtual: string): MenuItemDto[] {
  const cacheString = localStorage.getItem("menuItems");

  if (!cacheString) {
    console.error("Nenhum dado encontrado no localStorage.");
    return [];
  }

  let cacheObject: { data: MenuItemDto[]; timestamp: number };
  try {
    cacheObject = JSON.parse(cacheString);
  } catch (error) {
    console.error("Erro ao fazer o parse do objeto no localStorage:", error);
    return [];
  }

  const menuItems = cacheObject.data;
  if (!Array.isArray(menuItems)) {
    console.error('A propriedade "data" não é um array.');
    return [];
  }

  const rotasFiltradas = menuItems.filter(
    (item) =>
      item.rota && item.rota.startsWith(rotaAtual) && item.rota !== rotaAtual,
  );

  return rotasFiltradas;
}
export function criarMenuItem(nome: string, rota: string): MenuItemDto {
  const iconePadrao: IconName = "home";
  return {
    id: Math.random(),
    nome,
    rota,
    sequencia: 0,
    nivel: 0,
    idNivelAnterior: 0,
    icone: iconePadrao,
  };
}

export const getLabel = (
  options: { value: any; label: string }[],
  value: any,
  defaultDescription: string,
) => {
  return (
    options.find((option) => option.value === value)?.label ||
    defaultDescription
  );
};

export const parseDate = (dateString: string | null): Date | null => {
  if (dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime()) ? date : null;
  }
  return null;
};

export const ExtrairConsultaProdutoComando = (
  input: string,
): ProdutoConsultaComandoDto | null => {
  const sanitized = input.trim().toLowerCase();

  // Expressão regular para capturar valor (v), quantidade (x) e código do produto.
  const regex = /^(?:(\d+(?:[.,]\d+)?)v)?(?:(\d+(?:[.,]\d+)?)x)?([a-z0-9]+)$/i;
  const match = sanitized.match(regex);

  if (!match) return null;

  let [, valorStr, quantidadeStr, codigoProduto] = match;

  // Substitui vírgula por ponto e converte para float
  const parseDecimal = (value: string) => Number(value.replace(",", "."));

  return {
    valor: valorStr ? parseDecimal(valorStr) : undefined,
    quantidade: quantidadeStr ? parseDecimal(quantidadeStr) : undefined,
    codigoProduto,
  };
};
